module.exports = __webpack_public_path__ + "img/sidebar_cl_202627.5f0afee7.png";